import React from "react";
import s from "./limitsCustomers.scss";
import { useHistory, useLocation, Link } from "react-router-dom";
import cx from "classnames";
import QboxmailApi from "@/qboxmailApi";
import ResponsiveTable from "Components/responsiveTable/ResponsiveTable";
import { t } from "i18next";
import StatusBadge from "Components/statusBadge/StatusBadge";

const api = new QboxmailApi({ useCookie: true });

const formatType = (type) => {
  if (type === "both") {
    return "Sia transazionali che promozionali";
  }

  if (type === "transactional") {
    return "Transazionali";
  }

  if (type === "newsletter") {
    return "Promozionali";
  }
};
export default class Delivery extends React.Component {
  state = {
    loading: false,
  };

  letIn = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });

    await api.letInDeliveryWaitlist({ customer_code: this.props.customer.code });
    this.props.refreshCustomer(this.props.match.params.customerCode);

    this.setState({ loading: false });
  };

  render() {
    const { customer } = this.props;

    return (
      <form className={s.general} method="post" onSubmit={this.handleSubmit}>
        <div className={s.wrapInfoBtn}></div>

        <div className={s.settings}>
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">Utenze</div>
              <div className="sectionDesc">Overview delle utenze attive del cliente</div>
              <Link to={`/delivery/accounts?customer_code=${customer.code}`} className="text-sm">
                Vai alla sezione Email Delivery per questo cliente
              </Link>
            </div>
            <div className="w-full">
              <ResponsiveTable
                history={history}
                location={location}
                headers={[
                  { name: t("table.header.status"), size: "1rem" },
                  {
                    name: t("input.placeholder.id"),
                    key: "id",
                    size: "3rem",
                  },
                  { name: t("table.header.delivery.description"), size: "12rem" },
                ]}
                rows={customer.delivery_accounts.map((accountData) => (
                  <tr key={accountData.id}>
                    <td>
                      <div className="expand flexCenter">
                        <StatusBadge data={accountData} type="delivery-account" />
                      </div>
                    </td>
                    <td>
                      <Link to={`/customers/${customer.code}/delivery/accounts/${accountData.id}`} className="text-sm">
                        {accountData.id}
                      </Link>
                    </td>
                    <td>{accountData.description}</td>
                  </tr>
                ))}
                showAddIcon={false}
                showAddMsg={false}
                addDesc={t("delivery.domains.accounts.noAssociatedAccounts.desc")}
              />
            </div>
          </div>
        </div>
      </form>
    );
  }
}
